import { combineReducers } from 'redux'
import Login from "./Login";
import Notifications from "./Notifications";
import Security from "./Security";

const rootReducer = combineReducers({
    Login,
    Notifications,
    Security
});

export default rootReducer;